import { Controller } from "@hotwired/stimulus";

// A small controller to decouple a modal from its triggers.
//
// For example:
//
//   <button type="button"
//           data-controller="trigger"
//           data-action="trigger#pull"
//           data-trigger-modal-outlet="#the-modal">
//
//   <!-- Lots of other HTML. -->
//
//   <div id="the-modal">
//     ...
export default class extends Controller {
  static outlets = ["modal"];

  pull(event) {
    event.preventDefault();

    this.modalOutlet.open();
  }
}
